import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const getVendors = (params) => ({
  type: actionTypes.GET_VENDORS,
  params
});

export const createVendor = (payload) => ({
  type: actionTypes.CREATE_VENDOR,
  payload
});

export const updateVendor = (payload) => ({
  type: actionTypes.UPDATE_VENDOR,
  payload
});

export const updateVendorStatus = (Id) => ({
  type: actionTypes.UPDATE_VENDOR_STATUS,
  Id
});

export const deleteVendor = (Id) => ({
  type: actionTypes.DELETE_VENDOR,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});
